var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"pageTitle":"Sign Up Form"}},[_vm._v(" Sign Up Form ")])
}
var staticRenderFns = []

export { render, staticRenderFns }